import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';

export const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: ${COLORS.multiGray};

  @media only screen and (max-width: 1280px) {
    height: auto;
  }
`;

export const SignInContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
  width: 865px;
  height: 614px;
  margin-top: 100px;
  margin-bottom: 100px;
  padding-top: 100px;
  padding-left: 282px;
  padding-right: 282px;
  background: linear-gradient(
    155.67deg,
    rgba(255, 255, 255, 0.59) -7.08%,
    rgba(255, 255, 255, 0.13) 110.41%
  );
  border: 1px solid rgba(15, 66, 90, 0.33);
  box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  border-radius: 12px;
`;

export const SignInLogo = styled.img`
  width: 122px;
  height: 36px;
`;

export const TitlePage = styled.span`
  ${FONTS.font24};
  ${FONT_FAMILY.FontBold};
  color: ${COLORS.mainColor};
`;

export const SignInInput = styled.input`
  width: 100%;
  height: 46px;
  padding-left: 20px;
  padding-right: 30px;
  background: ${COLORS.white};
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 8px;

  &::placeholder {
    ${FONTS.font16};
    ${FONT_FAMILY.FontRegular};
  }
`;

export const SignInErrors = styled.span`
  position: absolute;
  left: 4px;
  top: 45px;
  color: ${COLORS.red};
  ${FONTS.font12};
  ${FONT_FAMILY.FontRegular};
`;

export const SignInButton = styled.button`
  width: 100%;
  height: 42px;
  background: ${COLORS.mainColor};
  border-radius: 8px;
  color: ${COLORS.white};
  ${FONTS.font18};
  ${FONT_FAMILY.FontRegular};

  &:hover {
    background: transparent;
    color: ${COLORS.mainColor};
    border: 1px solid ${COLORS.mainColor};
  }
`;

export const SimpleSpan = styled.span`
  position: relative;
  width: 100%;
`;

export const PasswordEye = styled.img`
  position: absolute;
  right: 5px;
  top: 14px;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;
